<template>
  <div :class="componentClassName">
    <a-page-heading>申し込み管理</a-page-heading>
    <m-section>
      <m-action-card title="申し込み情報編集" :header-border="true" :narrow-body="true">
        <form ref="form" class="t-setting-companys-edit__form" @submit.prevent="handleFormSubmit">
          <div v-if="companyInfoData" class="t-settings-companys-add__fields">
            <m-form-input label="契約ID">
              <a-text-field id="documentID" v-model="companyInfoData.documentID" type="text" :disabled="true" />
            </m-form-input>
            <m-form-input label="顧客ID（任意）">
              <a-text-field
                id="customerID"
                v-model="companyInfoData.customerID"
                type="text"
                maxlength="10"
                pattern="[0-9a-zA-Z]+"
                :disabled="readOnly"
              />
            </m-form-input>
            <m-form-input v-if="companyInfoData.voicedxOnlyFlag" label="個人名義・法人名義">
              <a-text-field id="individual" v-model="companyInfoData.individual" type="text" :disabled="true" />
            </m-form-input>
            <m-form-input v-if="companyInfoData.voicedxOnlyFlag" label="取引種別">
              <a-select-field
                id="inPersonTransactionFlagList"
                v-model="companyInfoData.inPersonTransactionFlag"
                :options="inPersonTransactionFlagList"
                :show-arrow="true"
                :disabled="readOnly"
              />
            </m-form-input>
            <m-form-input label="契約名義">
              <a-text-field
                id="companyName"
                v-model="companyInfoData.companyName"
                type="text"
                placeholder="入力してください"
                maxlength="40"
                :disabled="!businessTypeFlag || readOnly"
              />
            </m-form-input>
            <m-form-input label="契約名義カナ">
              <a-text-field
                id="companyKanaName"
                v-model="companyInfoData.companyKanaName"
                type="text"
                placeholder="全角カタカナ"
                maxlength="40"
                pattern="[ァ-ヶー 　]+"
                :disabled="!businessTypeFlag || readOnly"
              />
            </m-form-input>
            <m-form-input label="郵便番号">
              <a-text-field
                id="companyPostCode"
                v-model="companyInfoData.companyPostCode"
                type="text"
                placeholder="ハイフンなし"
                maxlength="7"
                pattern="[0-9]{7}"
                :disabled="!businessTypeFlag || readOnly"
              />
            </m-form-input>
            <m-form-input label="都道府県名">
              <a-select-field
                id="-companyAddress1"
                v-model="companyInfoData.companyAddress1"
                required
                :options="prefectures"
                :tabopen="tabopen"
                :disabled="!businessTypeFlag || readOnly"
              />
            </m-form-input>
            <m-form-input label="市区町村">
              <a-text-field
                id="companyAddress2"
                v-model="companyInfoData.companyAddress2"
                type="text"
                placeholder="入力してください"
                maxlength="20"
                :disabled="!businessTypeFlag || readOnly"
              />
            </m-form-input>
            <m-form-input label="字丁目番地など">
              <a-text-field
                id="companyAddress3"
                v-model="companyInfoData.companyAddress3"
                type="text"
                placeholder="入力してください"
                maxlength="20"
                :disabled="!businessTypeFlag || readOnly"
              />
            </m-form-input>
            <m-form-input label="住所建物など">
              <a-text-field
                id="companyAddress4"
                v-model="companyInfoData.companyAddress4"
                type="text"
                placeholder="入力してください"
                maxlength="20"
                :disabled="!businessTypeFlag || readOnly"
              />
            </m-form-input>
            <m-form-input label="事業内容">
              <a-text-field
                id="companyBusinessDetails"
                v-model="companyInfoData.companyBusinessDetails"
                type="text"
                placeholder="入力してください"
                maxlength="100"
                :disabled="!businessTypeFlag || readOnly"
              />
            </m-form-input>
            <m-form-input v-if="companyInfoData.voicedxOnlyFlag" label="法人番号">
              <a-text-field
                id="companyNumber"
                v-model="companyInfoData.companyNumber"
                type="text"
                placeholder=""
                maxlength="13"
                pattern="[0-9]+"
                :disabled="companyInfoData.businessType !== 'company' || readOnly"
              />
            </m-form-input>
            <m-form-input label="実質的支配者の有無">
              <a-radio
                id="companyRulerFlagOff"
                v-model="radio"
                name="flag"
                value="false"
                label="無"
                :disabled="!businessTypeFlag || readOnly"
                :error="getFieldError('companyRulerFlag')"
              />
              <a-radio
                id="companyRulerFlagOn"
                v-model="radio"
                name="flag"
                value="true"
                label="有"
                :disabled="!businessTypeFlag || readOnly"
                :error="getFieldError('companyRulerFlag')"
              />
            </m-form-input>
            <m-form-input label="実質的支配者名">
              <a-text-field
                id="companyRulerName"
                v-model="companyInfoData.companyRulerName"
                type="text"
                placeholder=""
                maxlength="40"
                :disabled="!companyRulerFlag || readOnly"
              />
            </m-form-input>
            <m-form-input label="実質的支配者住所">
              <a-text-field
                id="companyRulerAddress"
                v-model="companyInfoData.companyRulerAddress"
                type="text"
                placeholder=""
                maxlength="80"
                :disabled="!companyRulerFlag || readOnly"
              />
            </m-form-input>
            <m-form-input label="実質的支配者生年月日">
              <a-text-field
                id="companyRulerBirthDateView"
                v-model="companyInfoData.companyRulerBirthDateView"
                type="text"
                placeholder="YYYYMMDD"
                maxlength="8"
                pattern="[0-9]{8}"
                :disabled="!companyRulerFlag || readOnly"
              />
            </m-form-input>
            <m-form-input label="実質的支配者の法人との関係">
              <a-text-field
                id="companyRelationship"
                v-model="companyInfoData.companyRelationship"
                type="text"
                placeholder=""
                maxlength="20"
                :disabled="!companyRulerFlag || readOnly"
              />
            </m-form-input>
            <m-form-input label="実質的支配者名2">
              <a-text-field
                id="companyRulerName2"
                v-model="companyInfoData.companyRulerName2"
                type="text"
                placeholder=""
                maxlength="40"
                :disabled="!companyRulerFlag || readOnly"
              />
            </m-form-input>
            <m-form-input label="実質的支配者住所2">
              <a-text-field
                id="companyRulerAddress2"
                v-model="companyInfoData.companyRulerAddress2"
                type="text"
                placeholder=""
                maxlength="80"
                :disabled="!companyRulerFlag || readOnly"
              />
            </m-form-input>
            <m-form-input label="実質的支配者生年月日2">
              <a-text-field
                id="companyRulerBirthDateView2"
                v-model="companyInfoData.companyRulerBirthDateView2"
                type="text"
                placeholder="YYYYMMDD"
                maxlength="8"
                pattern="[0-9]{8}"
                :disabled="!companyRulerFlag || readOnly"
              />
            </m-form-input>
            <m-form-input label="実質的支配者の法人との関係2">
              <a-text-field
                id="companyRelationship2"
                v-model="companyInfoData.companyRelationship2"
                type="text"
                placeholder=""
                maxlength="20"
                :disabled="!companyRulerFlag || readOnly"
              />
            </m-form-input>
            <m-form-input label="実質的支配者名3">
              <a-text-field
                id="companyRulerName3"
                v-model="companyInfoData.companyRulerName3"
                type="text"
                placeholder=""
                maxlength="40"
                :disabled="!companyRulerFlag || readOnly"
              />
            </m-form-input>
            <m-form-input label="実質的支配者住所3">
              <a-text-field
                id="companyRulerAddress3"
                v-model="companyInfoData.companyRulerAddress3"
                type="text"
                placeholder=""
                maxlength="80"
                :disabled="!companyRulerFlag || readOnly"
              />
            </m-form-input>
            <m-form-input label="実質的支配者生年月日3">
              <a-text-field
                id="companyRulerBirthDateView3"
                v-model="companyInfoData.companyRulerBirthDateView3"
                type="text"
                placeholder="YYYYMMDD"
                maxlength="8"
                pattern="[0-9]{8}"
                :disabled="!companyRulerFlag || readOnly"
              />
            </m-form-input>
            <m-form-input label="実質的支配者の法人との関係3">
              <a-text-field
                id="companyRelationship3"
                v-model="companyInfoData.companyRelationship3"
                type="text"
                placeholder=""
                maxlength="20"
                :disabled="!companyRulerFlag || readOnly"
              />
            </m-form-input>
            <m-form-input label="実質的支配者名4">
              <a-text-field
                id="companyRulerName4"
                v-model="companyInfoData.companyRulerName4"
                type="text"
                placeholder=""
                maxlength="40"
                :disabled="!companyRulerFlag || readOnly"
              />
            </m-form-input>
            <m-form-input label="実質的支配者住所4">
              <a-text-field
                id="companyRulerAddress4"
                v-model="companyInfoData.companyRulerAddress4"
                type="text"
                placeholder=""
                maxlength="80"
                :disabled="!companyRulerFlag || readOnly"
              />
            </m-form-input>
            <m-form-input label="実質的支配者生年月日4">
              <a-text-field
                id="companyRulerBirthDateView4"
                v-model="companyInfoData.companyRulerBirthDateView4"
                type="text"
                placeholder="YYYYMMDD"
                maxlength="8"
                pattern="[0-9]{8}"
                :disabled="!companyRulerFlag || readOnly"
              />
            </m-form-input>
            <m-form-input label="実質的支配者の法人との関係4">
              <a-text-field
                id="companyRelationship4"
                v-model="companyInfoData.companyRelationship4"
                type="text"
                placeholder=""
                maxlength="20"
                :disabled="!companyRulerFlag || readOnly"
              />
            </m-form-input>
            <br />
            <p>マスタ管理者</p>
            <m-form-input label="氏名">
              <a-text-field
                id="adminLastName"
                v-model="companyInfoData.adminLastName"
                type="text"
                placeholder="入力してください"
                maxlength="20"
                required
                :disabled="readOnly"
              />
              <a-text-field
                id="adminNameView"
                v-model="companyInfoData.adminNameView"
                type="text"
                placeholder="入力してください"
                maxlength="20"
                required
                :disabled="readOnly"
              />
            </m-form-input>
            <m-form-input label="氏名カナ">
              <a-text-field
                id="adminLastKanaName"
                v-model="companyInfoData.adminLastKanaName"
                type="text"
                placeholder="全角カタカナ"
                pattern="[ァ-ヶー]+"
                maxlength="20"
                required
                :disabled="readOnly"
              />
              <a-text-field
                id="adminKanaNameView"
                v-model="companyInfoData.adminKanaNameView"
                type="text"
                placeholder="全角カタカナ"
                pattern="[ァ-ヶー]+"
                maxlength="20"
                required
                :disabled="readOnly"
              />
            </m-form-input>
            <m-form-input label="生年月日">
              <a-text-field
                id="adminBirthDateView"
                v-model="companyInfoData.adminBirthDateView"
                type="text"
                placeholder="YYYYMMDD"
                maxlength="8"
                pattern="[0-9]{8}"
                :disabled="readOnly"
              />
            </m-form-input>
            <m-form-input label="メールアドレス">
              <a-text-field
                id="adminEmail"
                v-model="companyInfoData.adminEmail"
                type="email"
                placeholder="キャリアメールは使えません"
                maxlength="50"
                required
                :disabled="contractChange"
              />
            </m-form-input>
            <m-form-input label="職業">
              <a-text-field
                id="adminJob"
                v-model="companyInfoData.adminJob"
                type="text"
                placeholder="入力してください"
                maxlength="20"
                required
                :disabled="readOnly"
              />
            </m-form-input>
            <m-form-input label="電話番号">
              <a-text-field
                id="adminPhoneNumber"
                v-model="companyInfoData.adminPhoneNumber"
                type="tel"
                placeholder="ハイフンなし"
                maxlength="11"
                pattern="[0-9]{10,11}"
                required
                :disabled="readOnly"
              />
            </m-form-input>
            <m-form-input label="郵便番号">
              <a-text-field
                id="adminPostCode"
                v-model="companyInfoData.adminPostCode"
                type="text"
                placeholder="ハイフンなし"
                maxlength="7"
                pattern="[0-9]{7}"
                required
                :disabled="readOnly"
              />
            </m-form-input>
            <m-form-input label="都道府県名">
              <a-select-field
                id="-adminAddress1"
                v-model="companyInfoData.adminAddress1"
                required
                :options="prefectures"
                :tabopen="tabopen"
                :disabled="readOnly"
              />
            </m-form-input>
            <m-form-input label="市区町村">
              <a-text-field
                id="adminAddress2"
                v-model="companyInfoData.adminAddress2"
                type="text"
                placeholder="入力してください"
                maxlength="20"
                :disabled="readOnly"
              />
            </m-form-input>
            <m-form-input label="字丁目番地など">
              <a-text-field
                id="adminAddress3"
                v-model="companyInfoData.adminAddress3"
                type="text"
                placeholder="入力してください"
                maxlength="20"
                :disabled="readOnly"
              />
            </m-form-input>
            <m-form-input label="住所建物など">
              <a-text-field
                id="adminAddress4"
                v-model="companyInfoData.adminAddress4"
                type="text"
                placeholder="入力してください"
                maxlength="20"
                :disabled="readOnly"
              />
            </m-form-input>

            <br />

            <div v-if="companyInfoData.documentID.indexOf('tmp_') !== -1">
              <p>営業担当者情報</p>
              <m-form-input label="販売チャネルコード">
                <a-text-field
                  id="salesChannelCode"
                  v-model="companyInfoData.salesChannelCode"
                  type="text"
                  placeholder=""
                  maxlength="8"
                  pattern="[0-9a-zA-Z]+"
                  :disabled="readOnly"
                />
              </m-form-input>
              <m-form-input label="販売担当者コード">
                <a-text-field
                  id="salesPersonCode"
                  v-model="companyInfoData.salesPersonCode"
                  type="text"
                  placeholder=""
                  maxlength="9"
                  pattern="[0-9a-zA-Z]+"
                  :disabled="readOnly"
                />
              </m-form-input>
            </div>
            <m-form-input v-if="companyInfoData.voicedxOnlyFlag" label="販売担当者氏名（姓名）">
              <a-text-field
                id="salesPerson"
                v-model="companyInfoData.salesPerson"
                type="text"
                placeholder=""
                maxlength="20"
                :disabled="readOnly"
              />
            </m-form-input>
            <m-form-input v-if="companyInfoData.voicedxOnlyFlag" label="販売担当者氏名カナ（姓名）">
              <a-text-field
                id="salesPersonKanaName"
                v-model="companyInfoData.salesPersonKanaName"
                type="text"
                placeholder=""
                maxlength="20"
                :disabled="readOnly"
              />
            </m-form-input>
            <m-form-input v-if="companyInfoData.voicedxOnlyFlag" label="販売担当者組織/部課名">
              <a-text-field
                id="salesPersonDepartment"
                v-model="companyInfoData.salesPersonDepartment"
                type="text"
                placeholder=""
                maxlength="20"
                :disabled="readOnly"
              />
            </m-form-input>
            <m-form-input v-if="companyInfoData.voicedxOnlyFlag" label="販売担当者メールアドレス">
              <a-text-field
                id="salesPersonEmailAddress"
                v-model="companyInfoData.salesPersonEmailAddress"
                type="email"
                placeholder=""
                maxlength="50"
                :disabled="readOnly"
              />
            </m-form-input>
            <m-form-input v-if="companyInfoData.voicedxOnlyFlag" label="販売担当者電話番号">
              <a-text-field
                id="salesPersonPhoneNumber"
                v-model="companyInfoData.salesPersonPhoneNumber"
                type="tel"
                placeholder="ハイフンなし"
                maxlength="11"
                pattern="[0-9]{10,11}"
                :disabled="readOnly"
              />
            </m-form-input>

            <br v-if="companyInfoData.voicedxOnlyFlag" />
            <p v-if="companyInfoData.voicedxOnlyFlag">お申し込み対応部門</p>
            <m-form-input v-if="companyInfoData.voicedxOnlyFlag" label="お申し込み受付担当者 氏名（姓名）">
              <a-text-field
                id="signupResponderName"
                v-model="companyInfoData.signupResponderName"
                type="text"
                placeholder=""
                maxlength="20"
                :disabled="readOnly"
              />
            </m-form-input>
            <m-form-input v-if="companyInfoData.voicedxOnlyFlag" label="お申し込み受付担当者 氏名カナ（姓名）">
              <a-text-field
                id="signupResponderNameKana"
                v-model="companyInfoData.signupResponderNameKana"
                type="text"
                placeholder=""
                maxlength="20"
                :disabled="readOnly"
              />
            </m-form-input>
            <m-form-input v-if="companyInfoData.voicedxOnlyFlag" label="お申し込み受付担当者 組織/部課名">
              <a-text-field
                id="signupResponderDepartment"
                v-model="companyInfoData.signupResponderDepartment"
                type="text"
                placeholder=""
                maxlength="20"
                :disabled="readOnly"
              />
            </m-form-input>
            <m-form-input v-if="companyInfoData.voicedxOnlyFlag" label="お申し込み受付担当者 メールアドレス">
              <a-text-field
                id="signupResponderMail"
                v-model="companyInfoData.signupResponderMail"
                type="email"
                placeholder=""
                maxlength="50"
                :disabled="readOnly"
              />
            </m-form-input>
            <m-form-input v-if="companyInfoData.voicedxOnlyFlag" label="お申し込み受付担当者 電話番号">
              <a-text-field
                id="signupResponderPhoneNumber"
                v-model="companyInfoData.signupResponderPhoneNumber"
                type="tel"
                placeholder="ハイフンなし"
                maxlength="11"
                pattern="[0-9]{10,11}"
                :disabled="readOnly"
              />
            </m-form-input>

            <br />
            <p>ヒアリング事項</p>
            <m-form-input label="利用目的">
              <div class="a-text-field a-text-field--text" required>
                <textarea
                  id="purposeOfUse"
                  v-model="companyInfoData.purposeOfUse"
                  class="a-text-field__input"
                  placeholder="入力してください"
                  maxlength="100"
                  required
                  :disabled="readOnly"
                />
              </div>
            </m-form-input>
            <m-form-input v-if="companyInfoData.voicedxOnlyFlag" label="利用予定の電話番号数（ご利用開始から1ヶ月間）">
              <a-text-field
                id="expectedNumberOfPhoneNumber"
                v-model="companyInfoData.expectedNumberOfPhoneNumber"
                type="text"
                placeholder=""
                maxlength="6"
                pattern="[0-9]+"
                :disabled="readOnly"
              />
            </m-form-input>
            <m-form-input v-if="companyInfoData.voicedxOnlyFlag" label="利用予定の電話番号数の最大値">
              <a-text-field
                id="expectedMaxNumberOfPhoneNumber"
                v-model="companyInfoData.expectedMaxNumberOfPhoneNumber"
                type="text"
                placeholder=""
                maxlength="6"
                pattern="[0-9]+"
                :disabled="readOnly"
              />
            </m-form-input>
            <m-form-input v-if="companyInfoData.voicedxOnlyFlag" label="利用予定の電話発信回数（1ヶ月あたり）の最大値">
              <a-text-field
                id="expectedMaxNumberOfOutgoingCalls"
                v-model="companyInfoData.expectedMaxNumberOfOutgoingCalls"
                type="text"
                placeholder=""
                maxlength="6"
                pattern="[0-9]+"
                :disabled="readOnly"
              />
            </m-form-input>
            <m-form-input
              v-if="companyInfoData.voicedxOnlyFlag === true"
              label="利用予定の電話着信回数（1ヶ月あたり）の最大値"
            >
              <a-text-field
                id="expectedMaxNumberOfIncomingCalls"
                v-model="companyInfoData.expectedMaxNumberOfIncomingCalls"
                type="text"
                placeholder=""
                maxlength="6"
                pattern="[0-9]+"
                :disabled="readOnly"
              />
            </m-form-input>
            <m-form-input v-if="companyInfoData.voicedxOnlyFlag === true" label="取引時確認書類の確認日時">
              <a-text-field
                id="documentCheckDay"
                v-model="companyInfoData.documentCheckDay"
                type="text"
                placeholder="yyyymmddHHMM"
                maxlength="12"
                pattern="[0-9]{12}"
                :disabled="readOnly || companyInfoData.inPersonTransactionFlag !== 'true'"
              />
            </m-form-input>
            <m-form-input
              v-if="companyInfoData.voicedxOnlyFlag === true"
              label="「契約に関する責任者連絡先」欄の確認を行った書類"
            >
              <a-select-field
                id="documentTypeList"
                v-model="companyInfoData.documentType"
                class="a-business-hour-input-field__start"
                :options="documentTypeList"
                :show-arrow="true"
                :disabled="readOnly || companyInfoData.inPersonTransactionFlag !== 'true'"
              />
            </m-form-input>
            <m-form-input
              v-if="companyInfoData.voicedxOnlyFlag === true"
              label="取引の任に当たっていることを確認した方法"
            >
              <a-select-field
                id="inPersonCertificateType"
                v-model="companyInfoData.inPersonCertificateType"
                class="a-business-hour-input-field__start"
                :options="inPersonCertificateTypeList"
                :show-arrow="true"
                :disabled="readOnly"
              />
            </m-form-input>

            <br />
            <p>請求書送付先</p>
            <m-form-input label="郵便番号">
              <a-text-field
                id="invoicePostCode"
                v-model="companyInfoData.invoicePostCode"
                type="text"
                placeholder="ハイフンなし"
                maxlength="7"
                pattern="[0-9]{7}"
                :disabled="readOnly"
              />
            </m-form-input>
            <m-form-input label="都道府県名">
              <a-select-field
                id="-invoiceAddress1"
                v-model="companyInfoData.invoiceAddress1"
                required
                :options="prefectures"
                :tabopen="tabopen"
                :disabled="readOnly"
              />
            </m-form-input>
            <m-form-input label="市区町村">
              <a-text-field
                id="invoiceAddress2"
                v-model="companyInfoData.invoiceAddress2"
                type="text"
                placeholder="入力してください"
                maxlength="20"
                :disabled="readOnly"
              />
            </m-form-input>
            <m-form-input label="字丁目番地など">
              <a-text-field
                id="invoiceAddress3"
                v-model="companyInfoData.invoiceAddress3"
                type="text"
                placeholder="入力してください"
                maxlength="20"
                :disabled="readOnly"
              />
            </m-form-input>
            <m-form-input label="住所建物など">
              <a-text-field
                id="invoiceAddress4"
                v-model="companyInfoData.invoiceAddress4"
                type="text"
                placeholder="入力してください"
                maxlength="20"
                :disabled="readOnly"
              />
            </m-form-input>
            <m-form-input label="宛名"></m-form-input>
            <div class="a-invoice-padding">
              <m-form-input label="請求書送付先①カナ(必須)">
                <a-text-field
                  id="invoiceDestinationNameKana"
                  v-model="companyInfoData.invoiceKanaName"
                  type="text"
                  placeholder="入力してください"
                  maxlength="35"
                  :disabled="readOnly"
                />
              </m-form-input>
              <div class="a-invoice-text-title">
                <span class="a-invoice-text">請求書送付先①②の登録内容: </span>
                {{ companyInfoData.invoiceName }}
              </div>
              <m-form-input label="請求書送付先①(必須)">
                <a-text-field
                  id="invoiceEditCompany"
                  v-model="invoiceNameData.invoiceCompany"
                  type="text"
                  placeholder="変更内容を入力してください。請求書送付先①②ともに変更しない場合は、空欄のまま登録してください（請求書送付先①だけ入力すると、請求書送付先②は削除されます）"
                  maxlength="20"
                  :disabled="readOnly"
                  :class-custom-placeholder="'a-invoice-input'"
                />
              </m-form-input>
              <m-form-input label="請求書送付先②">
                <a-text-field
                  id="invoiceEditDepartment"
                  v-model="invoiceNameData.invoiceDepartment"
                  type="text"
                  placeholder="変更内容を入力してください。請求書送付先①②ともに変更しない場合は、空欄のまま登録してください（請求書送付先①だけ入力すると、請求書送付先②は削除されます）"
                  maxlength="20"
                  :disabled="readOnly"
                  :class-custom-placeholder="'a-invoice-input'"
                />
              </m-form-input>
            </div>
            <m-form-input label="電話番号">
              <a-text-field
                id="invoicePhoneNumber"
                v-model="companyInfoData.invoicePhoneNumber"
                type="tel"
                placeholder="ハイフンなし"
                maxlength="11"
                pattern="[0-9]{10,11}"
                :disabled="readOnly"
              />
            </m-form-input>

            <br />
            <p>その他</p>
            <m-form-input label="支払い方法">
              <a-text-field id="billType" v-model="companyInfoData.billType" type="text" :disabled="readOnly" />
            </m-form-input>
            <m-form-input label="開通希望日">
              <a-text-field
                id="openDayView"
                v-model="companyInfoData.openDayView"
                type="text"
                placeholder="YYYYMMDD"
                maxlength="8"
              />
            </m-form-input>
            <m-form-input label="契約ステータス">
              <a-text-field
                id="contractStatusView"
                v-model="companyInfoData.contractStatusView"
                type="text"
                :disabled="true"
              />
            </m-form-input>
            <m-form-input label="SOステータス">
              <a-text-field id="soStatusView" v-model="companyInfoData.soStatusView" type="text" :disabled="true" />
            </m-form-input>
            <m-form-input label="備考">
              <div class="a-text-field a-text-field--text">
                <textarea
                  id="note"
                  v-model="companyInfoData.note"
                  class="a-text-field__input"
                  placeholder=""
                  maxlength="200"
                  :disabled="readOnly"
                />
              </div>
            </m-form-input>
            <m-form-input label="応対者">
              <a-text-field
                id="responderName"
                v-model="companyInfoData.responderName"
                type="text"
                maxlength="41"
                :disabled="readOnly"
              />
            </m-form-input>

            <template
              v-if="
                certificateInfo.DriverlicenseURL1 ||
                certificateInfo.DriverlicenseURL2 ||
                certificateInfo.MyNumberURL ||
                certificateInfo.DrivingHistoryURL1 ||
                certificateInfo.DrivingHistoryURL2 ||
                certificateInfo.SealRegistrationURL ||
                certificateInfo.FamilyRegisterURL ||
                certificateInfo.CertificateOfResidenceURL
              "
            >
              <br />
              <h3 id="certificateInfoConfirmH3">本人確認書類</h3>
            </template>
            <template v-if="certificateInfo.DriverlicenseURL1">
              <div v-if="!readOnly">
                <a id="DriverlicenseURL1" @click="open_file(certificateInfo.DriverlicenseURL1)">運転免許証1</a>
              </div>
              <div v-if="readOnly">運転免許証1</div>
            </template>
            <template v-if="certificateInfo.DriverlicenseURL2">
              <div v-if="!readOnly">
                <a id="DriverlicenseURL2" @click="open_file(certificateInfo.DriverlicenseURL2)">運転免許証2</a>
              </div>
              <div v-if="readOnly">運転免許証2</div>
            </template>
            <template v-if="certificateInfo.MyNumberURL">
              <div v-if="!readOnly">
                <a id="MyNumberURL" @click="open_file(certificateInfo.MyNumberURL)">マイナンバー</a>
              </div>
              <div v-if="readOnly">マイナンバー</div>
            </template>
            <template v-if="certificateInfo.DrivingHistoryURL1">
              <div v-if="!readOnly">
                <a id="DrivingHistoryURL1" @click="open_file(certificateInfo.DrivingHistoryURL1)">運転経歴証明書1</a>
              </div>
              <div v-if="readOnly">運転経歴証明書1</div>
            </template>
            <template v-if="certificateInfo.DrivingHistoryURL2">
              <div v-if="!readOnly">
                <a id="DrivingHistoryURL2" @click="open_file(certificateInfo.DrivingHistoryURL2)">運転経歴証明書2</a>
              </div>
              <div v-if="readOnly">運転経歴証明書2</div>
            </template>
            <template v-if="certificateInfo.SealRegistrationURL">
              <div v-if="!readOnly">
                <a id="SealRegistrationURL" @click="open_file(certificateInfo.SealRegistrationURL)">印鑑登録証明書</a>
              </div>
              <div v-if="readOnly">印鑑登録証明書</div>
            </template>
            <template v-if="certificateInfo.FamilyRegisterURL">
              <div v-if="!readOnly">
                <a id="FamilyRegisterURL" @click="open_file(certificateInfo.FamilyRegisterURL)">戸籍の附票</a>
              </div>
              <div v-if="readOnly">戸籍の附票</div>
            </template>
            <template v-if="certificateInfo.CertificateOfResidenceURL">
              <div v-if="!readOnly">
                <a id="CertificateOfResidenceURL" @click="open_file(certificateInfo.CertificateOfResidenceURL)"
                  >住民票</a
                >
              </div>
              <div v-if="readOnly">住民票</div>
            </template>
            <template
              v-if="
                certificateInfo.copyOfCompanyRegisterURL1 ||
                certificateInfo.copyOfCompanyRegisterURL2 ||
                certificateInfo.copyOfCompanyRegisterURL3 ||
                certificateInfo.copyOfCompanyRegisterURL4 ||
                certificateInfo.copyOfCompanyRegisterURL5 ||
                certificateInfo.copyOfCompanyRegisterURL6 ||
                certificateInfo.copyOfCompanyRegisterURL7 ||
                certificateInfo.copyOfCompanyRegisterURL8 ||
                certificateInfo.copyOfCompanyRegisterURL9 ||
                certificateInfo.copyOfCompanyRegisterURL10
              "
            >
              <br />
              <h3 id="certificateInfoH3">登記事項証明書</h3>
            </template>
            <template v-if="certificateInfo.copyOfCompanyRegisterURL1">
              <div v-if="!readOnly">
                <a id="copyOfCompanyRegisterURL1" @click="open_file(certificateInfo.copyOfCompanyRegisterURL1)"
                  >登記事項証明書1</a
                >
              </div>
              <div v-if="readOnly">登記事項証明書1</div>
            </template>
            <template v-if="certificateInfo.copyOfCompanyRegisterURL2">
              <div v-if="!readOnly">
                <a id="copyOfCompanyRegisterURL2" @click="open_file(certificateInfo.copyOfCompanyRegisterURL2)"
                  >登記事項証明書2</a
                >
              </div>
              <div v-if="readOnly">登記事項証明書2</div>
            </template>
            <template v-if="certificateInfo.copyOfCompanyRegisterURL3">
              <div v-if="!readOnly">
                <a id="copyOfCompanyRegisterURL3" @click="open_file(certificateInfo.copyOfCompanyRegisterURL3)"
                  >登記事項証明書3</a
                >
              </div>
              <div v-if="readOnly">登記事項証明書3</div>
            </template>
            <template v-if="certificateInfo.copyOfCompanyRegisterURL4">
              <div v-if="!readOnly">
                <a id="copyOfCompanyRegisterURL4" @click="open_file(certificateInfo.copyOfCompanyRegisterURL4)"
                  >登記事項証明書4</a
                >
              </div>
              <div v-if="readOnly">登記事項証明書4</div>
            </template>
            <template v-if="certificateInfo.copyOfCompanyRegisterURL5">
              <div v-if="!readOnly">
                <a id="copyOfCompanyRegisterURL5" @click="open_file(certificateInfo.copyOfCompanyRegisterURL5)"
                  >登記事項証明書5</a
                >
              </div>
              <div v-if="readOnly">登記事項証明書5</div>
            </template>
            <template v-if="certificateInfo.copyOfCompanyRegisterURL6">
              <div v-if="!readOnly">
                <a id="copyOfCompanyRegisterURL6" @click="open_file(certificateInfo.copyOfCompanyRegisterURL6)"
                  >登記事項証明書6</a
                >
              </div>
              <div v-if="readOnly">登記事項証明書6</div>
            </template>
            <template v-if="certificateInfo.copyOfCompanyRegisterURL7">
              <div v-if="!readOnly">
                <a id="copyOfCompanyRegisterURL7" @click="open_file(certificateInfo.copyOfCompanyRegisterURL7)"
                  >登記事項証明書7</a
                >
              </div>
              <div v-if="readOnly">登記事項証明書7</div>
            </template>
            <template v-if="certificateInfo.copyOfCompanyRegisterURL8">
              <div v-if="!readOnly">
                <a id="copyOfCompanyRegisterURL8" @click="open_file(certificateInfo.copyOfCompanyRegisterURL8)"
                  >登記事項証明書8</a
                >
              </div>
              <div v-if="readOnly">登記事項証明書8</div>
            </template>
            <template v-if="certificateInfo.copyOfCompanyRegisterURL9">
              <div v-if="!readOnly">
                <a id="copyOfCompanyRegisterURL9" @click="open_file(certificateInfo.copyOfCompanyRegisterURL9)"
                  >登記事項証明書9</a
                >
              </div>
              <div v-if="readOnly">登記事項証明書9</div>
            </template>
            <template v-if="certificateInfo.copyOfCompanyRegisterURL10">
              <div v-if="!readOnly">
                <a id="copyOfCompanyRegisterURL10" @click="open_file(certificateInfo.copyOfCompanyRegisterURL10)"
                  >登記事項証明書10</a
                >
              </div>
              <div v-if="readOnly">登記事項証明書10</div>
            </template>

            <template v-if="certificateInfo.letterOfAttorneyURL">
              <h3 id="letterOfAttorneyH3">委任状</h3>
              <div v-if="!readOnly">
                <a id="letterOfAttorneyURL" @click="open_file(certificateInfo.letterOfAttorneyURL)">委任状</a>
              </div>
              <div v-if="readOnly">委任状</div>
            </template>
          </div>

          <m-form-action-buttons>
            <template v-if="!readOnly">
              <template v-if="!contractChange">
                <a-button
                  v-if="companyInfoData"
                  id="submit"
                  variant="block"
                  color="primary"
                  submit="submit"
                  :disabled="!flagAllButtonsEnable"
                  >保存</a-button
                >
                <a-button
                  v-if="companyInfoData"
                  id="approval"
                  variant="block"
                  color="primary"
                  :disabled="!flagAllButtonsEnable"
                  @click="handleCompanyApproval"
                  >開通</a-button
                >
              </template>
              <template v-if="contractChange">
                <a-button
                  v-if="companyInfoData"
                  id="submit"
                  variant="block"
                  color="primary"
                  submit="submit"
                  :disabled="!flagAllButtonsEnable"
                  >保存</a-button
                >
                <a-button
                  v-if="companyInfoData"
                  id="approval2"
                  variant="block"
                  color="primary"
                  :disabled="!flagAllButtonsEnable"
                  @click="handleCompanyApproval2"
                  >承認</a-button
                >
                <a-button
                  v-if="companyInfoData"
                  id="reject2"
                  variant="block"
                  color="primary"
                  :disabled="!flagAllButtonsEnable"
                  @click="handleCompanyReject2"
                  >否認</a-button
                >
              </template>
            </template>
            <a-button
              id="cancel"
              variant="outlined"
              color="primary"
              :disabled="!flagAllButtonsEnable"
              @click="handleCancelClick"
            >
              キャンセル
            </a-button>
          </m-form-action-buttons>

          <template v-if="!readOnly">
            <template v-if="!contractChange">
              <div class="m-form-action-buttons">
                <div class="m-button-container m-button-container__delete">
                  <a-button
                    v-if="companyInfoData"
                    id="reject"
                    :inline="true"
                    variant="block"
                    color="gray"
                    style="margin: 24px 0 0"
                    size="middle"
                    :disabled="!flagAllButtonsEnable"
                    @click="handleCompanyReject"
                    >審査NG</a-button
                  >
                </div>
              </div>
            </template>
          </template>
        </form>
      </m-action-card>
    </m-section>
  </div>
  <teleport to="body">
    <o-modal
      id="settingCompanyRequestEdit_resultModal"
      v-model:visible="resultModalVisible"
      class="o-modal-remove-phone-number-confirmation"
      footer-variant="confirmation"
      width="442px"
      :footer-shadow="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <template #title>{{ resultModalTitle }}</template>
      <a-text>
        <!-- eslint-disable -->
        <span v-html="resultModalContent" />
        <!-- eslint-enable -->
      </a-text>
      <template #footer>
        <a-button id="ok" variant="block" color="primary" label="OK" size="small" @click="handleCloseModal(next)" />
      </template>
    </o-modal>
  </teleport>

  <teleport to="body">
    <o-modal
      v-if="companyConfirmVisible"
      id="settingCompanyRequestEdit_confirmModal"
      v-model:visible="companyConfirmVisible"
      class="o-modal-remove-user-confirmation"
      footer-variant="confirmation"
      width="442px"
      :footer-shadow="false"
      @close="handleCancelCompanyConfirm"
    >
      <template #title>{{ resultModalTitle }}</template>
      <a-text :center="true">
        <!-- eslint-disable -->
        <!-- <span v-html="resultModalContent" /> -->
        <span v-html="resultModalContent" />
        <!-- eslint-enable -->
      </a-text>
      <template #footer>
        <a-button
          id="yes"
          variant="block"
          color="primary"
          label="はい"
          size="small"
          @click="handleConfirmCompany(type)"
        />
        <a-button
          id="no"
          variant="outlined"
          color="primary"
          label="いいえ"
          size="small"
          @click="handleCancelCompanyConfirm"
        />
      </template>
    </o-modal>
  </teleport>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import APageHeading from '@/components/atoms/page-heading';
import MSection from '@/components/molecules/section';
import MActionCard from '@/components/molecules/action-card';
import AButton from '@/components/atoms/button';
import MFormInput from '@/components/molecules/form-input';
import ATextField from '@/components/atoms/text-field';
import ASelectField from '@/components/atoms/select-field';
import { cloneDeep } from 'lodash';

import { customRequest } from '@/common/customRequest.js';
import { messageContent } from '@/common/messageContent.js';
import { customValidate } from '@/common/customValidate.js';
import { POINT } from '@/libs/constants';
import { PREFECTURES } from '@/libs/constants';
import { JOBS } from '@/libs/constants';

export default {
  name: 't-setting-companys-edit',
  components: {
    APageHeading,
    MSection,
    MActionCard,
    AButton,
    MFormInput,
    ATextField,
    ASelectField,
  },
  mixins: [customRequest, customValidate],
  beforeRouteEnter(to, from, next) {
    next(async vm => {
      await vm.initialize();
    });
  },
  props: {
    class: {
      type: String,
      default: '',
    },
    companyID: {
      type: String,
      default: '',
    },
    username: {
      type: String,
      default: '',
    },
    authInfo: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      companyInfoData: {
        newCompanyID: '',
        companyName: '',
        customerID: '',
        inPersonTransactionFlag: '',
        companyKanaName: '',
        companyPostCode: '',
        companyAddress1: '',
        companyAddress2: '',
        companyAddress3: '',
        companyAddress4: '',
        companyBusinessDetails: '',
        companyNumber: '',
        companyRulerFlag: '',
        companyRulerName: '',
        companyRulerAddress: '',
        companyRulerBirthDate: '',
        companyRelationship: '',
        companyRulerName2: '',
        companyRulerAddress2: '',
        companyRulerBirthDate2: '',
        companyRelationship2: '',
        companyRulerName3: '',
        companyRulerAddress3: '',
        companyRulerBirthDate3: '',
        companyRelationship3: '',
        companyRulerName4: '',
        companyRulerAddress4: '',
        companyRulerBirthDate4: '',
        companyRelationship4: '',
        adminLastName: '',
        adminName: '',
        adminLastKanaName: '',
        adminKanaName: '',
        //adminDepartment: '',
        adminBirthDate: '',
        adminEmail: '',
        adminJob: '',
        adminPhoneNumber: '',
        adminPostCode: '',
        adminAddress1: '',
        adminAddress2: '',
        adminAddress3: '',
        adminAddress4: '',
        purposeOfUse: '',
        invoicePostCode: '',
        invoiceAddress1: '',
        invoiceAddress2: '',
        invoiceAddress3: '',
        invoiceAddress4: '',
        invoiceName: '',
        invoiceKanaName: '',
        invoiceDepartment: '',
        invoicePhoneNumber: '',
        businessType: '',
        note: '',
        adminNameView: '',
        adminKanaNameView: '',
        openDay: '',
        startDate: '',
        responderName: '',
        billType: '',
        voicedxOnlyFlag: '',
        soStatus: '',
        contractStatus: '',
        documentID: '',
        key: '',
        billTypeView: '',
        voicedxOnlyFlagView: '',
        contractStatusView: '',
        soStatusView: '',
        salesChannelCode: '',
        salesPersonCode: '',
        salesPerson: '',
        salesPersonKanaName: '',
        salesPersonEmailAddress: '',
        salesPersonPhoneNumber: '',
        salesPersonDepartment: '',
        expectedNumberOfPhoneNumber: '',
        expectedMaxNumberOfPhoneNumber: '',
        expectedMaxNumberOfOutgoingCalls: '',
        expectedMaxNumberOfIncomingCalls: '',
        signupResponderName: '',
        signupResponderNameKana: '',
        signupResponderMail: '',
        signupResponderPhoneNumber: '',
        signupResponderDepartment: '',
        inPersonCertificateType: '',
        documentCheckDay: '',
        documentType: '',
      },
      copyOfCompanyData: {},
      certificateInfo: {},
      resultModalTitle: '',
      resultModalContent: '',
      resultModalVisible: false,
      DriverlicenseURL1: '',
      DriverlicenseURL2: '',
      MyNumberURL: '',
      DrivingHistoryURL1: '',
      DrivingHistoryURL2: '',
      SealRegistrationURL: '',
      FamilyRegisterURL: '',
      CertificateOfResidenceURL: '',
      copyOfCompanyRegisterURL1: '',
      copyOfCompanyRegisterURL2: '',
      copyOfCompanyRegisterURL3: '',
      copyOfCompanyRegisterURL4: '',
      copyOfCompanyRegisterURL5: '',
      copyOfCompanyRegisterURL6: '',
      copyOfCompanyRegisterURL7: '',
      copyOfCompanyRegisterURL8: '',
      copyOfCompanyRegisterURL9: '',
      copyOfCompanyRegisterURL10: '',
      letterOfAttorneyURL: '',
      devCompanyIDPrefixes: ['003', '004', '005'],
      companyIDList: [],
      radio: 'false',
      contractChange: false,
      companyRulerFlag: false,
      companyConfirmVisible: false,
      businessTypeFlag: false,
      flagAllButtonsEnable: true, // #2512
      submitFlag: false,
      formData: {
        documents: [{}],
      },
      businessTypeList: [
        {
          value: '',
          label: '選択してください',
        },
        {
          value: 'individual',
          label: '個人',
        },
        {
          value: 'company',
          label: '法人',
        },
      ],
      inPersonTransactionFlagList: [
        { label: '対面取引', value: 'true' },
        { label: '非対面取引', value: 'false' },
      ],
      documentTypeList: [
        { label: '運転免許証', value: 'driverLicense' },
        { label: 'マイナンバーカード', value: 'myNumberCard' },
      ],
      inPersonCertificateTypeList: [
        {
          label: 'NTTコム営業担当者が「ビデオや電話会議または対面での会議」での協議にて、口頭で確認済み',
          value: 'salesPersonCheck',
        },
        { label: 'NTTコム営業担当者が委任状を目視にて確認済み', value: 'letterOfCommission' },
        { label: 'NTTコム営業担当者に委任状の写しをメールで提出', value: 'letterOfCommissionCopy' },
      ],
      projectEnv: '',
      // #2456
      spCharCheckListCompany: [
        {
          name: '契約名義',
          fieldName: 'companyName',
        },
        {
          name: '顧客ID',
          fieldName: 'customerID',
        },
        {
          name: '契約名義カナ',
          fieldName: 'companyKanaName',
        },
        {
          name: '郵便番号',
          fieldName: 'companyPostCode',
        },
        {
          name: '都道府県名',
          fieldName: 'companyAddress1',
        },
        {
          name: '市区町村',
          fieldName: 'companyAddress2',
        },
        {
          name: '字丁目番地など',
          fieldName: 'companyAddress3',
        },
        {
          name: '住所建物など',
          fieldName: 'companyAddress4',
        },
        {
          name: '事業内容',
          fieldName: 'companyBusinessDetails',
        },
        {
          name: '法人番号',
          fieldName: 'companyNumber',
        },
      ],
      spCharCheckListRuler: [
        {
          name: '実質的支配者名',
          fieldName: 'companyRulerName',
        },
        {
          name: '実質的支配者住所',
          fieldName: 'companyRulerAddress',
        },
        {
          name: '実質的支配者生年月日',
          fieldName: 'companyRulerBirthDate',
        },
        {
          name: '実質的支配者の法人との関係',
          fieldName: 'companyRelationship',
        },
        {
          name: '実質的支配者名2',
          fieldName: 'companyRulerName2',
        },
        {
          name: '実質的支配者住所2',
          fieldName: 'companyRulerAddress2',
        },
        {
          name: '実質的支配者生年月日2',
          fieldName: 'companyRulerBirthDateView2',
        },
        {
          name: '実質的支配者の法人との関係2',
          fieldName: 'companyRelationship2',
        },
        {
          name: '実質的支配者名3',
          fieldName: 'companyRulerName3',
        },
        {
          name: '実質的支配者住所3',
          fieldName: 'companyRulerAddress3',
        },
        {
          name: '実質的支配者生年月日3',
          fieldName: 'companyRulerBirthDateView3',
        },
        {
          name: '実質的支配者の法人との関係3',
          fieldName: 'companyRelationship3',
        },
        {
          name: '実質的支配者名4',
          fieldName: 'companyRulerName4',
        },
        {
          name: '実質的支配者住所4',
          fieldName: 'companyRulerAddress4',
        },
        {
          name: '実質的支配者生年月日4',
          fieldName: 'companyRulerBirthDateView4',
        },
        {
          name: '実質的支配者の法人との関係4',
          fieldName: 'companyRelationship4',
        },
      ],
      spCharCheckList: [
        {
          name: 'マスタ管理者.氏名',
          fieldName: 'adminLastName',
        },
        {
          name: 'マスタ管理者.氏名',
          fieldName: 'adminNameView',
        },
        {
          name: 'マスタ管理者.氏名カナ',
          fieldName: 'adminLastKanaName',
        },
        {
          name: 'マスタ管理者.氏名カナ',
          fieldName: 'adminKanaName',
        },
        {
          name: 'マスタ管理者.生年月日',
          fieldName: 'adminBirthDate',
        },
        {
          name: 'マスタ管理者.メールアドレス',
          fieldName: 'adminEmail',
        },
        {
          name: 'マスタ管理者.職業',
          fieldName: 'adminJob',
        },
        {
          name: 'マスタ管理者.電話番号',
          fieldName: 'adminPhoneNumber',
        },
        {
          name: 'マスタ管理者.郵便番号',
          fieldName: 'adminPostCode',
        },
        {
          name: 'マスタ管理者.都道府県名',
          fieldName: 'adminAddress1',
        },
        {
          name: 'マスタ管理者.市区町村',
          fieldName: 'adminAddress2',
        },
        {
          name: 'マスタ管理者.字丁目番地など',
          fieldName: 'adminAddress3',
        },
        {
          name: 'マスタ管理者.住所建物など',
          fieldName: 'adminAddress4',
        },
      ],
      spCharCheckListSalesPerson: [
        { name: '営業担当者情報.販売チャネルコード', fieldName: 'salesChannelCode' },
        { name: '営業担当者情報.販売担当者コード', fieldName: 'salesPersonCode' },
        { name: '営業担当者情報.販売担当者氏名（姓名）', fieldName: 'salesPerson' },
        { name: '営業担当者情報.販売担当者氏名カナ（姓名）', fieldName: 'salesPersonKanaName' },
        { name: '営業担当者情報.販売担当者組織/部課名', fieldName: 'salesPersonDepartment' },
        { name: '営業担当者情報.販売担当者メールアドレス', fieldName: 'salesPersonEmailAddress' },
        { name: '営業担当者情報.販売担当者電話番号', fieldName: 'salesPersonPhoneNumber' },
      ],
      spCharCheckListSignupResponder: [
        { name: 'お申し込み対応部門.お申し込み受付担当者 氏名（姓名）', fieldName: 'signupResponderName' },
        { name: 'お申し込み対応部門.お申し込み受付担当者 氏名カナ（姓名）', fieldName: 'signupResponderNameKana' },
        { name: 'お申し込み対応部門.お申し込み受付担当者 組織/部課名', fieldName: 'signupResponderDepartment' },
        { name: 'お申し込み対応部門.お申し込み受付担当者 メールアドレス', fieldName: 'signupResponderMail' },
        { name: 'お申し込み対応部門.お申し込み受付担当者 電話番号', fieldName: 'signupResponderPhoneNumber' },
      ],
      spCharCheckListHearing: [
        { name: 'ヒアリング事項.利用目的', fieldName: 'purposeOfUse' },
        {
          name: 'ヒアリング事項.利用予定の電話番号数（ご利用開始から1ヶ月間）',
          fieldName: 'expectedNumberOfPhoneNumber',
        },
        {
          name: 'ヒアリング事項.利用予定の電話番号数の最大値',
          fieldName: 'expectedMaxNumberOfPhoneNumber',
        },
        {
          name: 'ヒアリング事項.利用予定の電話発信回数（1ヶ月あたり）の最大値',
          fieldName: 'expectedMaxNumberOfOutgoingCalls',
        },
        {
          name: 'ヒアリング事項.利用予定の電話着信回数（1ヶ月あたり）の最大値',
          fieldName: 'expectedMaxNumberOfIncomingCalls',
        },
        { name: 'ヒアリング事項.取引時確認書類の確認日時', fieldName: 'documentCheckDay' },
        { name: 'ヒアリング事項.「契約に関する責任者連絡先」欄の確認を行った書類', fieldName: 'documentType' },
        { name: 'ヒアリング事項.取引の任に当たっていることを確認した方法', fieldName: 'inPersonCertificateType' },
      ],
      spCharCheckAddressInvoice: [
        {
          name: '請求書送付先①',
          fieldName: 'invoiceCompany',
        },
        {
          name: '請求書送付先②',
          fieldName: 'invoiceDepartment',
        },
      ],
      spCharCheckListInvoice: [
        {
          name: '請求書送付先.郵便番号',
          fieldName: 'invoicePostCode',
        },
        {
          name: '請求書送付先.都道府県名',
          fieldName: 'invoiceAddress1',
        },
        {
          name: '請求書送付先.市区町村',
          fieldName: 'invoiceAddress2',
        },
        {
          name: '請求書送付先.字丁目番地など',
          fieldName: 'invoiceAddress3',
        },
        {
          name: '請求書送付先.住所建物など',
          fieldName: 'invoiceAddress4',
        },
        {
          name: '請求書送付先.送付先名',
          fieldName: 'invoiceName',
        },
        {
          name: '請求書送付先.送付先名カナ',
          fieldName: 'invoiceKanaName',
        },
        {
          name: '請求書送付先.電話番号',
          fieldName: 'invoicePhoneNumber',
        },
      ],
      spCharCheckListOther: [
        {
          name: 'その他.支払い方法',
          fieldName: 'billType',
        },
        {
          name: 'その他.開通希望日',
          fieldName: 'openDay',
        },
        {
          name: 'その他.応対者',
          fieldName: 'responderName',
        },
        {
          name: 'その他.備考',
          fieldName: 'note',
        },
      ],
      readOnly: false,
      prefectures: [],
      jobs: [],
      invoiceNameData: {
        invoiceCompany: '',
        invoiceDepartment: '',
      },
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-setting-companys-edit');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  mounted() {
    const documentID = this.$route.query.documentID;
    this.prefectures = PREFECTURES;
    this.jobs = JOBS;

    if (this.companyID !== POINT) {
      this.$router.push({ path: '/permission-denied' });
      return;
    }

    if (this.authInfo === 'operator' || (documentID === POINT && this.authInfo === 'soOperator')) {
      this.readOnly = true;
    }

    if (documentID) {
      this.postRequest('/contract/getRequestData', {
        getDocumentID: documentID,
        companyID: this.companyInfoData.documentID,
      })
        .then(e => {
          if (e.status === 'success') {
            const arrAdminName = e.data.adminName.split('_');
            e.data.adminLastName = arrAdminName[0];
            e.data.adminNameView = arrAdminName[1];

            e.data.adminLastKanaName = '';
            e.data.adminKanaNameView = '';
            if (typeof e.data.adminKanaName !== 'undefined') {
              if (e.data.adminKanaName !== '') {
                const arrAdminKanaName = e.data.adminKanaName.split('_');
                e.data.adminLastKanaName = arrAdminKanaName[0];
                e.data.adminKanaNameView = arrAdminKanaName[1];
              }
            }

            if (typeof e.data.adminBirthDate !== 'undefined') {
              e.data.adminBirthDateView = e.data.adminBirthDate.replace(/-/g, '');
            }

            if (typeof e.data.companyRulerBirthDate !== 'undefined') {
              e.data.companyRulerBirthDateView = e.data.companyRulerBirthDate.replace(/-/g, '');
            }

            let companyRulerNo = '';
            const arrInput = [
              'companyRulerName',
              'companyRulerAddress',
              'companyRulerBirthDate',
              'companyRelationship',
            ];
            for (let i = 0; i < 4; i++) {
              if (i > 0) {
                companyRulerNo = String(i + 1);
              }

              for (let j = 0; j < arrInput.length; j++) {
                if (typeof e.data[arrInput[j] + companyRulerNo] === 'undefined') {
                  e.data[arrInput[j] + companyRulerNo] = '';
                }
              }
              e.data['companyRulerBirthDateView' + companyRulerNo] = e.data[
                'companyRulerBirthDate' + companyRulerNo
              ].replace(/-/g, '');
            }

            if (e.data.businessType === 'individual') {
              this.businessTypeFlag = false;
              e.data.individual = '個人';
            } else if (e.data.businessType === 'company') {
              this.businessTypeFlag = true;
              e.data.individual = '法人';
            }

            e.data.billType = '請求書払い';

            if (e.data.voicedxOnlyFlag) {
              e.data.voicedxOnlyFlagView = 'COTOHA Voice DX Basicのみ';
            } else {
              e.data.voicedxOnlyFlagView = 'COTOHA Voice DX Basic・COTOHA Call Center共用';
            }

            if (e.data.contractStatus === 'use') {
              e.data.contractStatusView = '利用中';
            } else if (e.data.contractStatus === 'suspend') {
              e.data.contractStatusView = '利用停止';
            } else if (e.data.contractStatus === 'close') {
              e.data.contractStatusView = '解約';
            }

            if (e.data.soStatus === 'review') {
              e.data.soStatusView = '審査中';
            } else if (e.data.soStatus === 'pass') {
              e.data.soStatusView = '合格';
            } else if (e.data.soStatus === 'fail') {
              e.data.soStatusView = '審査不合格';
            }

            if (e.data.companyRulerFlag === true) {
              this.radio = 'true';
            } else {
              if (e.data.companyRulerFlag === 'true') {
                this.radio = 'true';
              } else {
                this.radio = 'false';
              }
            }

            if (typeof e.data.openDay !== 'undefined' && e.data.openDay !== null) {
              e.data.openDayView = e.data.openDay.replace(/-/g, '');
            } else {
              e.data.openDayView = '';
            }

            // 都道府県名プルダウン値の処理
            let address1Msg = '';
            let found = this.prefectures.find(element => element.value === e.data.adminAddress1);
            if (typeof found === 'undefined') {
              address1Msg = messageContent.alertNotCorrectFormat('マスタ管理者:都道府県名') + '<br>';
              e.data.adminAddress1 = '';
            }

            found = this.prefectures.find(element => element.value === e.data.invoiceAddress1);
            if (typeof found === 'undefined') {
              address1Msg += messageContent.alertNotCorrectFormat('請求書送付先:都道府県名') + '<br>';
              e.data.invoiceAddress1 = '';
            }

            found = this.prefectures.find(element => element.value === e.data.companyAddress1);
            if (typeof found === 'undefined') {
              address1Msg += messageContent.alertNotCorrectFormat('法人情報:都道府県名');
              e.data.companyAddress1 = '';
            }

            if (address1Msg !== '') {
              this.showErrorModal(address1Msg);
            }

            // 職業を変換して値セット
            found = this.jobs.find(element => element.value === e.data.adminJob);
            if (typeof found !== 'undefined') {
              e.data.adminJob = found.label;
            }

            // 対面フラグをstring化
            if (typeof e.data.inPersonTransactionFlag === 'boolean') {
              e.data.inPersonTransactionFlag = e.data.inPersonTransactionFlag.toString();
            } else {
              e.data.inPersonTransactionFlag = '';
            }

            if (e.data.documentID.indexOf('tmp_') !== -1) {
              this.contractChange = false;
            } else {
              this.contractChange = true;
            }

            this.companyInfoData = e.data;
            this.certificateInfo = e.data2;
            this.copyOfCompanyData = cloneDeep(this.companyInfoData);
          } else {
            this.showErrorModal(messageContent.requireTry('申し込みデータ取得'));
          }
        })
        .catch(() => {
          this.showErrorModal(messageContent.requireTry('申し込みデータ取得'));
        });
    }
  },
  methods: {
    initialize: function () {
      if (this.companyID !== POINT) {
        this.$router.push({ path: '/permission-denied' });
      }
      this.handlerFetchCompanyData();
    },
    // 保存時の処理
    handleFormSubmit(event) {
      event.preventDefault();
      if (!this.checkMySpecialCharactor()) {
        return;
      }
      this.submitFlag = true;
      this.handleCompanyEdit(cloneDeep(this.companyInfoData));
    },
    createSendData(sendData) {
      const adminBirthDate = sendData.adminBirthDateView;
      let y = adminBirthDate.substr(0, 4);
      let m = adminBirthDate.substr(4, 2);
      let d = adminBirthDate.substr(6);
      sendData.adminBirthDate = y + '-' + m + '-' + d;
      delete sendData.adminBirthDateView;

      const openDay = sendData.openDayView;
      if (openDay === '') {
        sendData.openDay = '';
      } else {
        y = openDay.substr(0, 4);
        m = openDay.substr(4, 2);
        d = openDay.substr(6);
        sendData.openDay = y + '-' + m + '-' + d;
      }
      delete sendData.openDayView;

      let companyRulerNo = '';
      for (let i = 0; i < 4; i++) {
        if (i > 0) {
          companyRulerNo = String(i + 1);
        }

        const companyRulerBirthDate = sendData['companyRulerBirthDateView' + companyRulerNo];
        if (companyRulerBirthDate !== '' && typeof companyRulerBirthDate !== 'undefined') {
          const y = companyRulerBirthDate.substr(0, 4);
          const m = companyRulerBirthDate.substr(4, 2);
          const d = companyRulerBirthDate.substr(6);
          sendData['companyRulerBirthDate' + companyRulerNo] = y + '-' + m + '-' + d;
        } else {
          sendData['companyRulerBirthDate' + companyRulerNo] = '';
        }
        delete sendData['companyRulerBirthDateView' + companyRulerNo];
      }

      sendData.adminName = sendData.adminNameView;
      delete sendData.adminNameView;

      sendData.adminKanaName = sendData.adminKanaNameView;
      delete sendData.adminKanaNameView;

      sendData.companyRulerFlag = false;
      if (this.radio === 'true') {
        sendData.companyRulerFlag = true;
      }

      if (typeof sendData.purposeOfUse !== 'undefined') {
        sendData.purposeOfUse = sendData.purposeOfUse.replace(/\n/g, '%%n%%');
      }

      // #2138
      if (typeof sendData.note !== 'undefined') {
        sendData.note = sendData.note.replace(/\n/g, '%%n%%');
      }

      if (sendData.responderName === '') {
        sendData.responderName = this.username;
      }

      // 職業を変換して値セット
      const found = this.jobs.find(element => element.label === sendData.adminJob);
      if (typeof found !== 'undefined') {
        sendData.adminJob = found.value;
      }

      // 対面フラグをboolean化
      switch (sendData.inPersonTransactionFlag) {
        case 'true':
          sendData.inPersonTransactionFlag = true;
          break;
        case 'false':
          sendData.inPersonTransactionFlag = false;
          break;
        default:
          sendData.inPersonTransactionFlag = undefined;
      }

      delete sendData.timestamp;
      delete sendData.soStatusView;
      delete sendData.billTypeView;
      delete sendData.voicedxOnlyFlagView;
    },
    handleCompanyEdit(sendData) {
      // 送付先名を編集
      const resultUpdateInvoiceName = this.updateDataInvoiceName(sendData);
      if (!resultUpdateInvoiceName) return;
      // #2512
      this.flagAllButtonsEnable = false;
      this.createSendData(sendData);
      this.postRequest('/entry/update', { data: sendData, companyID: this.companyInfoData.documentID })
        .then(e => {
          if (e.status === 'success') {
            this.showInfoModal(messageContent.notifyApplyInfoChanged(), '/companyrequest');
          } else {
            if (e.msg !== '') {
              this.showErrorModal(e.msg);
            } else {
              this.showErrorModal(messageContent.requireTry('申し込み情報の変更'));
            }
          }
        })
        .catch(() => {
          this.showErrorModal(messageContent.requireTry('申し込み情報の変更'));
        });
    },
    // 開通ボタン押下時の処理（モーダル表示)
    handleCompanyApproval() {
      // #2456
      if (!this.checkMySpecialCharactor()) {
        return;
      } else if (this.submitFlag === false) {
        this.companyConfirmVisible = true;
        this.resultModalTitle = '開通の確認';
        this.resultModalContent = '変更した場合、必ず保存してください。開通してよろしいですか？';
        this.type = 'approval';
      } else {
        this.companyConfirmVisible = true;
        this.resultModalTitle = '開通の確認';
        this.resultModalContent = '開通でよろしいですか？';
        this.type = 'approval';
      }
    },
    // 開通時の処理（モーダルでOKボタン押下後の処理）
    submitCompanyApproval() {
      this.companyConfirmVisible = false;
      const devCompanyIDPrefixes = this.devCompanyIDPrefixes;
      const companyIDList = this.companyIDList;
      let unique = false;
      let numstr = '';
      this.flagCreateEnable = false;

      if (this.projectEnv === 'production') {
        while (!unique) {
          numstr = this.randomNumStr(6);
          const numstrPrefix = numstr.slice(0, 3);
          if (devCompanyIDPrefixes.includes(numstrPrefix) || companyIDList.includes(numstr)) {
            unique = false;
            numstr = '';
          } else {
            unique = true;
          }
        }
      } else {
        while (!unique) {
          const numstr1 = devCompanyIDPrefixes[Math.floor(Math.random() * devCompanyIDPrefixes.length)];
          const numstr2 = this.randomNumStr(3);
          numstr = numstr1 + numstr2;
          if (companyIDList.includes(numstr)) {
            unique = false;
            numstr = '';
          } else {
            unique = true;
          }
        }
      }

      const documentID = this.$route.query.documentID;
      const key_type = this.companyInfoData.key;
      const updCompanyID = numstr;

      if (this.submitFlag === false) {
        this.companyInfoData = cloneDeep(this.copyOfCompanyData);
      }
      const sendData = cloneDeep(this.companyInfoData);
      sendData.newCompanyID = numstr;
      this.createSendData(sendData);

      // invoiceKanaName required
      sendData.invoiceKanaNameRequired = false;
      // 送付先名を編集
      const resultUpdateInvoiceName = this.updateDataInvoiceName(sendData);
      if (!resultUpdateInvoiceName) return;

      this.postRequest('/entry/create', { data: sendData, companyID: this.companyInfoData.documentID })
        .then(e => {
          if (e.status === 'success') {
            this.companyConfirmVisible = false;
            this.showInfoModal(messageContent.notifyCompanyInfoAdd(), '/companyrequest');
          } else {
            if (typeof e.msg !== 'undefined' && e.msg !== '') {
              this.showErrorModal(e.msg);
            } else {
              this.showErrorModal(messageContent.requireTry('企業情報の登録'));
            }
          }
        })
        .catch(() => {
          this.showErrorModal(messageContent.requireTry('企業情報の登録'));
        });
    },
    // 契約変更 承認時の処理
    handleCompanyApproval2() {
      const documentID = this.$route.query.documentID;
      const key_type = this.companyInfoData.key;
      const origData = cloneDeep(this.copyOfCompanyData);
      const sendData = cloneDeep(this.companyInfoData);
      // 送付先名を編集
      const resultUpdateInvoiceName = this.updateDataInvoiceName(sendData);
      if (!resultUpdateInvoiceName) return;

      const arrCompanyRuler = [
        'companyRulerName',
        'companyRulerAddress',
        'companyRulerBirthDateView',
        'companyRelationship',
      ];
      delete origData.timestamp;
      delete sendData.timestamp;
      let flgEdit = false;
      for (const key in sendData) {
        if (origData[key] !== sendData[key]) {
          // 実質的支配者の有無が「無」のとき、実質的支配者の項目はチェックしない
          if (origData.companyRulerFlag === false && arrCompanyRuler.indexOf(key.slice(0, -1)) !== -1) {
            flgEdit = false;
          } else {
            flgEdit = true;
            break;
          }
        }
      }
      // 実質的支配者の有無変更チェック
      if (this.radio !== String(origData.companyRulerFlag)) {
        flgEdit = true;
      }
      if (flgEdit) {
        this.showErrorModal('変更した場合、必ず保存してください。');
        return;
      }

      // #2512
      this.flagAllButtonsEnable = false;

      this.postRequest('/contract/approval', {
        setDocumentID: documentID,
        key_type: key_type,
        updCompanyID: documentID,
        companyID: this.companyInfoData.documentID,
      })
        .then(e => {
          if (e.status === 'success') {
            this.showInfoModal(messageContent.notifyChangeApplyAccepted(), '/companyrequest');
          } else {
            if (e.msg !== '') {
              this.showErrorModal(e.msg);
            } else {
              this.showErrorModal(messageContent.requireTry('変更申請'));
            }
          }
        })
        .catch(() => {
          this.showErrorModal(messageContent.requireTry('変更申請'));
        });
    },
    // 審査NGボタン押下時の処理（モーダル表示のみ）
    handleCompanyReject() {
      // #2456
      if (!this.checkMySpecialCharactor()) {
        return;
      }
      this.companyConfirmVisible = true;
      this.resultModalTitle = '審査NGの確認';
      this.resultModalContent = '審査NGでよろしいですか？';
      this.type = 'reject';
    },
    // 審査NG時の処理（モーダルでOKボタン押下後の処理）
    submitCompanyReject() {
      this.companyConfirmVisible = false;
      const documentID = this.$route.query.documentID;
      const key = this.companyInfoData.key;
      const adminmail = this.companyInfoData.adminEmail;

      this.postRequest('/contract/reject', {
        documentID: documentID,
        key: key,
        adminmail: adminmail,
        contractChange: this.contractChange,
        companyID: this.companyInfoData.documentID,
      })
        .then(e => {
          if (e.status === 'success') {
            // #2512
            this.flagAllButtonsEnable = true;
            this.$router.push('/companyrequest');
          } else {
            this.showErrorModal(messageContent.requireTry('SOステータスの変更'));
            this.companyConfirmVisible = false; //#1892から派生
          }
        })
        .catch(() => {
          this.showErrorModal(messageContent.requireTry('SOステータスの変更'));
          this.companyConfirmVisible = false; //#1892から派生
        });
    },
    // 契約変更 否認時の処理
    handleCompanyReject2() {
      const documentID = this.$route.query.documentID;
      const key = this.companyInfoData.key;
      const adminmail = this.companyInfoData.adminEmail;

      // #2512
      this.flagAllButtonsEnable = false;

      this.postRequest('/contract/reject', {
        documentID: documentID,
        key: key,
        adminmail: adminmail,
        contractChange: this.contractChange,
        companyID: this.companyInfoData.documentID,
      })
        .then(e => {
          if (e.status === 'success') {
            this.showInfoModal(messageContent.notifyStatusChangeToRejected(), '/companyrequest');
          } else {
            this.showErrorModal(messageContent.requireTry('ステータスの変更'));
          }
        })
        .catch(() => {
          this.showErrorModal(messageContent.requireTry('ステータスの変更'));
        });
    },
    handleCancelClick() {
      this.$router.push('/companyrequest');
    },
    handleCloseModal(next) {
      // #2512
      this.flagAllButtonsEnable = true;
      if (next) {
        this.$router.push(next);
      }

      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
    },
    open_file: async function (file_name) {
      await this.postRequest('/entry/download', { file_name: file_name, companyID: this.companyInfoData.documentID })
        .then(e => {
          if (e.status === 'failed') {
            this.showErrorModal(messageContent.requireTry('データの取得'));
            return;
          }

          const blob = this.base64ImageToBlob(e.data);
          const url = URL.createObjectURL(blob);
          const a = document.createElement('a');
          document.body.appendChild(a);
          a.download = file_name;
          a.href = url;
          a.click();
          a.remove();
          URL.revokeObjectURL(url);
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('データの取得'));
        });
    },
    base64ImageToBlob(str) {
      // extract content type and base64 payload from original string
      const pos = str.indexOf(';base64,');
      const type = str.substring(5, pos);
      const b64 = str.substr(pos + 8);

      // decode base64
      const imageContent = window.atob(b64);

      // create an ArrayBuffer and a view (as unsigned 8-bit)
      const buffer = new ArrayBuffer(imageContent.length);
      const view = new Uint8Array(buffer);
      // fill the view, using the decoded base64
      for (let n = 0; n < imageContent.length; n++) {
        view[n] = imageContent.charCodeAt(n);
      }
      // convert ArrayBuffer to Blob
      const blob = new Blob([buffer], { type: type });
      return blob;
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
    showInfoModal(message, next = '') {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
      this.next = next;
    },
    randomNumStr(length) {
      const content = '0123456789';
      const cl = content.length;
      let numStr = '';
      for (let i = 0; i < length; i++) {
        numStr += content[Math.floor(Math.random() * cl)];
      }
      return numStr;
    },
    getFieldError(key) {
      if (key === 'companyRulerFlag') {
        if (this.radio === 'true') {
          this.companyRulerFlag = true;
        } else if (this.radio === 'false') {
          this.companyRulerFlag = false;
        }
      }
    },
    handleCancelCompanyConfirm() {
      this.companyConfirmVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
    },
    // 開通or審査NG時のモーダルでOKを押下した後の処理
    handleConfirmCompany(type) {
      // #2456
      if (!this.checkMySpecialCharactor()) {
        return;
      }
      // #2512
      this.flagAllButtonsEnable = false;
      if (type === 'approval') {
        this.submitCompanyApproval();
      } else if (type === 'reject') {
        this.submitCompanyReject();
      }
    },
    handlerFetchCompanyData: function () {
      this.postRequest('/entry/getinitdata', { companyID: this.companyInfoData.documentID })
        .then(e => {
          if (e.status === 'success') {
            this.companyList = e.data;
            const companyIDList = [];
            for (let i = 0; i < e.data.length; i++) {
              companyIDList.push(e.data[i].companyID);
            }
            this.companyIDList = companyIDList;
            this.projectEnv = e.projectEnv;
          } else {
            this.showErrorModal(messageContent.requireTry('企業情報の取得'));
          }
        })
        .catch(() => {
          this.showErrorModal(messageContent.requireTry('企業情報の取得'));
        });
    },
    // #2456
    checkMySpecialCharactor: function () {
      if (this.companyInfoData.businessType === 'company') {
        // 特殊記号のチェック：法人情報
        for (const item of this.spCharCheckListCompany) {
          if (this.hasSpecialCharacterInObject({ keyWord: this.companyInfoData[item.fieldName] })) {
            this.showErrorModal(messageContent.requireNotSpecialCharacter(item.name));
            return false;
          }
        }
        // 特殊記号のチェック：実質的支配者の情報
        if (this.radio === 'true') {
          for (const item of this.spCharCheckListRuler) {
            if (this.hasSpecialCharacterInObject({ keyWord: this.companyInfoData[item.fieldName] })) {
              this.showErrorModal(messageContent.requireNotSpecialCharacter(item.name));
              return false;
            }
          }
        }
      }
      // 特殊記号のチェック：マスタ管理者
      for (const item of this.spCharCheckList) {
        if (
          this.hasSpecialCharacterInObject({
            keyWord: this.companyInfoData[item.fieldName]
              ? this.companyInfoData[item.fieldName].replace(/\r?\n/g, '')
              : '',
          })
        ) {
          this.showErrorModal(messageContent.requireNotSpecialCharacter(item.name));
          return false;
        }
      }
      // 特殊記号のチェック：営業担当者情報
      for (const item of this.spCharCheckListSalesPerson) {
        if (this.hasSpecialCharacterInObject({ keyWord: this.companyInfoData[item.fieldName] })) {
          this.showErrorModal(messageContent.requireNotSpecialCharacter(item.name));
          return false;
        }
      }
      // 特殊記号のチェック：お申し込み対応部門
      for (const item of this.spCharCheckListSignupResponder) {
        if (this.hasSpecialCharacterInObject({ keyWord: this.companyInfoData[item.fieldName] })) {
          this.showErrorModal(messageContent.requireNotSpecialCharacter(item.name));
          return false;
        }
      }
      // 特殊記号のチェック：ヒアリング事項
      for (const item of this.spCharCheckListHearing) {
        if (this.hasSpecialCharacterInObject({ keyWord: this.companyInfoData[item.fieldName] })) {
          this.showErrorModal(messageContent.requireNotSpecialCharacter(item.name));
          return false;
        }
      }
      // 特殊記号のチェック：請求書情報
      for (const item of this.spCharCheckListInvoice) {
        if (this.hasSpecialCharacterInObject({ keyWord: this.companyInfoData[item.fieldName] })) {
          this.showErrorModal(messageContent.requireNotSpecialCharacter(item.name));
          return false;
        }
      }
      // 特殊記号のチェック：その他
      for (const item of this.spCharCheckListOther) {
        if (
          this.hasSpecialCharacterInObject({
            keyWord: this.companyInfoData[item.fieldName]
              ? this.companyInfoData[item.fieldName].replace(/\r?\n/g, '')
              : '',
          })
        ) {
          this.showErrorModal(messageContent.requireNotSpecialCharacter(item.name));
          return false;
        }
      }

      // 特殊記号のチェック：請求書送付先①②
      for (const item of this.spCharCheckAddressInvoice) {
        if (
          this.hasSpecialCharacterInObjectInvoice({
            keyWord: this.invoiceNameData[item.fieldName].replace(/\r?\n/g, ''),
          })
        ) {
          this.showErrorModal(messageContent.invoiceRequireNotSpecialCharacter(item.name));
          return false;
        }
      }
      return true;
    },
    // 「請求書送付先①」と「請求書送付先②」処理
    updateDataInvoiceName(data) {
      // 請求書送付先②がある、請求書送付先①nullチェック
      if (this.invoiceNameData.invoiceDepartment && !this.invoiceNameData.invoiceCompany) {
        this.showErrorModal(messageContent.invoiceCompanyRequired);
        return false;
      }
      //「請求書送付先①」と「請求書送付先②」から送付先名に変換する
      if (!this.invoiceNameData.invoiceDepartment && this.invoiceNameData.invoiceCompany) {
        data.invoiceName = this.invoiceNameData.invoiceCompany;
      } else if (this.invoiceNameData.invoiceDepartment && this.invoiceNameData.invoiceCompany) {
        data.invoiceName = this.invoiceNameData.invoiceCompany + '／' + this.invoiceNameData.invoiceDepartment;
      }
      return true;
    },
  },
};
</script>
